import { Tooltip } from '@mui/material';
import { cn } from '../../utilities/cn';
import { FunctionComponent } from 'react';

interface InfoIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  tooltip: string;
  iconClassName?: string;
}

const InfoIcon: FunctionComponent<InfoIconProps> = ({
  tooltip,
  iconClassName = '',
  ...props
}: InfoIconProps) => {
  return (
    <Tooltip
      title={tooltip}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          className: cn(
            'bg-white text-gray-700 p-2.5 border border-gray-200 rounded-lg shadow-sm text-sm max-w-xs',
            props.className,
          ),
        },
        arrow: {
          sx: {
            color: 'white',
            '&::before': {
              border: '1px solid #e5e7eb',
              boxSizing: 'border-box',
            },
          },
        },
      }}
    >
      <span
        className={cn(
          'inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full border border-gray-300 bg-white text-center text-[10px] font-semibold text-gray-700 shadow-sm',
          iconClassName,
        )}
      >
        <span className="leading-none">i</span>
      </span>
    </Tooltip>
  );
};

export default InfoIcon;
